import { CSSProperties } from "react";

const FolderIcon = ({ scale, color, style }: { scale?: number; color?: string; style?: CSSProperties }) => {
  let c = "#95A3B5";
  if (color) c = color;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${scale || 1})` }}
    >
      <path
        d="M21 8.25V18C21 18.3978 20.842 18.7794 20.5607 19.0607C20.2794 19.342 19.8978 19.5 19.5 19.5H4.5C4.10218 19.5 3.72064 19.342 3.43934 19.0607C3.15804 18.7794 3 18.3978 3 18V6C3 5.60218 3.15804 5.22064 3.43934 4.93934C3.72064 4.65804 4.10218 4.5 4.5 4.5H9C11.25 4.5 11.25 6.75 12.75 6.75H19.5023C20.331 6.75 21 7.42125 21 8.25Z"
        stroke={c}
        strokeWidth="1.2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default FolderIcon;
